type SortParam<T extends string> = T | `-${T}`;

type Ordering<T extends string> = {
  direction: 'asc' | 'desc';
  column: T;
};

export type SortColumn<T extends string> = Exclude<SortParam<T>, `-${T}`>;

export const getOrderingParam = <T extends string>({
  direction,
  column,
}: Ordering<T>): SortParam<T> => {
  if (direction === 'desc') {
    return `-${column}`;
  }

  return column;
};

export const getSortValue = <T extends string>(
  ordering: SortParam<T>
): Ordering<T> => {
  const direction = ordering && ordering[0] === '-' ? 'desc' : 'asc';
  const column = (
    ordering && ordering[0] === '-' ? ordering.slice(1) : ordering
  ) as SortColumn<T>;

  return { direction, column };
};
